
@if (isLoading()) {
  <div class="loading">
    <app-loading-indicator />
  </div>
  }

<form [formGroup]="annotationForm" (ngSubmit)="onSubmit()" id="addAnnotationForm">
    <h2 class="form-title">{{ titleName }}</h2>
  
    <div class="control-row" id="annotationLabel">
      <div class="control no-margin">
        <label for="annotationLabel">Label</label>
        <input
          class="form-control"
          type="text"
          id="annotationLabel"
          name="annotationLabel"
          formControlName="label"
        />
      </div>
      @if(annotationForm.controls.label.touched && annotationForm.controls.label.errors?.['required']) {
        <div class="error-message">
          <strong style="color: #ff8080;">Label is required.</strong>
        </div>
      }
      @if(annotationForm.controls.label.touched && annotationForm.controls.label.errors?.['maxlength']) {
        <div class="error-message">
          <strong style="color: #ff8080;">Label must be less than 100 characters.</strong>
        </div>
      }
      @if(annotationForm.controls.label.touched && annotationForm.controls.label.errors?.['minlength']) {    
        <div class="error-message"> 
            <strong style="color: #ff8080;">Label must be at least 1 character.</strong>
        </div>
      }
    </div>
  
    <div class="control-row">
      <div class="control no-margin">
        <label for="annotationType">Annotation Type:</label>
        <p-dropdown
          autoWidth="false"
          [style]="{ width: '100%' }"
          appendTo="body"
          [options]="annotationTypes"
          formControlName="type"
          optionValue="value"
          optionLabel="text"
          id="annotationTypeDropdown"
        >
        </p-dropdown>
        <label for="annotationTypeTooltip">
            <i class="pi pi-info-circle">
                <span class="tooltip-text">
                    {{ tooltipText() }}
                </span>
            </i>
        </label>
      </div>
    </div>

    @if(isTextType()) {
    <div class="control-row">
        <div class="control no-margin">
            <label for="textPosition">Position:</label>
            <p-dropdown
                id="textPosition"
                [options]="textPositionOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="selectedTextPosition"
                (onChange)="onTextPositionChange()"
                placeholder="Select position"
                class="w-100"
            ></p-dropdown>
        </div>
        @if(annotationForm.controls.yAxisMin.touched && annotationForm.controls.yAxisMin.errors?.['yAxisMinRequired']) {
          <div class="error-message">
            <strong style="color: #ff8080;">Position is required.</strong>
          </div>
        }
    </div>
    }

    @if(needsYAxisMin() && !isTextType()) {
    <div class="control-row">
        <div class="control no-margin">
            <label for="yAxisMin">Y Axis Min:</label>
            <input
                class="form-control"
                type="number"
                id="yAxisMin"
                name="yAxisMin"
                formControlName="yAxisMin"
            />
        </div>
        @if(annotationForm.controls.yAxisMin.touched && annotationForm.controls.yAxisMin.errors?.['yAxisMinRequired']) {
          <div class="error-message">
            <strong style="color: #ff8080;">Y Axis Min is required.</strong>
          </div>
        }
        @if(annotationForm.controls.yAxisMin.touched && annotationForm.controls.yAxisMin.errors?.['yAxisMinGreaterThanMax']) {
          <div class="error-message">
            <strong style="color: #ff8080;">Y Axis Min must be less than Y Axis Max.</strong>
          </div>
        }
    </div>
    }

    @if(needsYAxisMax() && !isTextType()) {
    <div class="control-row">
        <div class="control no-margin">
            <label for="yAxisMax">Y Axis Max:</label>
            <input
                class="form-control"
                type="number"
                id="yAxisMax"
                name="yAxisMax"
                formControlName="yAxisMax"
            />
        </div>
        @if(annotationForm.controls.yAxisMax.touched && annotationForm.controls.yAxisMax.errors?.['yAxisMaxRequired']) {
          <div class="error-message">
            <strong style="color: #ff8080;">Y Axis Max is required.</strong>
          </div>
        }
        @if(annotationForm.controls.yAxisMax.touched && annotationForm.controls.yAxisMax.errors?.['yAxisMaxLessThanMin']) {
          <div class="error-message">
            <strong style="color: #ff8080;">Y Axis Max must be greater than Y Axis Min.</strong>
          </div>
        }
    </div>
    }

    @if(needsStartDate()) {
    <div class="control-row">
        <div class="control no-margin">
            <label for="startDate">{{ isPointType() ? 'Date:' : 'Start Date:' }}</label>
            <input
                class="form-control"
                [type]="isPointType() ? 'date' : 'datetime-local'"
                id="startDate"
                name="startDate"
                formControlName="startDate"
            />
        </div>
        @if(annotationForm.controls.startDate.touched && annotationForm.controls.startDate.errors?.['startDateRequired']) {
          <div class="error-message">
            <strong style="color: #ff8080;">{{ isPointType() ? 'Date' : 'Start Date' }} is required.</strong>
          </div>
        }
        @if(annotationForm.controls.startDate.touched && annotationForm.controls.startDate.errors?.['startDateGreaterThanEndDate']) {
          <div class="error-message">
            <strong style="color: #ff8080;">Start Date must be less than End Date.</strong>
          </div>
        }
    </div>
    }

    @if(needsYValueStartForPoint()) {
    <div class="control-row">
        <div class="control no-margin">
            <label for="yValueStart">Value:</label>
            <input
                class="form-control"
                type="number"
                id="yValueStart"
                name="yValueStart"
                formControlName="yAxisMin"
            />
        </div>
        @if(annotationForm.controls.yAxisMin.touched && annotationForm.controls.yAxisMin.errors?.['yValueStartRequired']) {
          <div class="error-message">
            <strong style="color: #ff8080;">Value is required.</strong>
          </div>
        }
    </div>
    }

    @if(needsEndDate()) {
    <div class="control-row">
        <div class="control no-margin">
            <label for="endDate">End Date:</label>
            <input
                class="form-control"
                type="datetime-local"
                seconds="false"
                id="endDate"
                name="endDate"
                formControlName="endDate"
            />
        </div>
        @if(annotationForm.controls.endDate.touched && annotationForm.controls.endDate.errors?.['endDateRequired']) {
          <div class="error-message">
            <strong style="color: #ff8080;">End Date is required.</strong>
          </div>
        }
        @if(annotationForm.controls.endDate.touched && annotationForm.controls.endDate.errors?.['endDateLessThanStartDate']) {
          <div class="error-message">
            <strong style="color: #ff8080;">End Date must be greater than Start Date.</strong>
          </div>
        }
    </div>
    }

    <div class="control-row">
        <div class="control no-margin">
            <label for="notes">Color:</label>
            <input
                class="form-control"
                type="color"
                id="color"
                name="color"
                formControlName="color"
            />
        </div>
    </div>

    <div class="control-row">
        <div class="control no-margin">
            <label for="labelFontSize">Label Font Size (px):</label>
            <input
                class="form-control"
                type="number"
                id="labelFontSize"
                name="labelFontSize"
                min="8"
                max="72"
                formControlName="labelFontSize"
            />
        </div>
        @if(annotationForm.controls.labelFontSize.touched && annotationForm.controls.labelFontSize.errors?.['min']) {
          <div class="error-message">
            <strong style="color: #ff8080;">Label Font Size must be at least 8.</strong>
          </div>
        }
        @if(annotationForm.controls.labelFontSize.touched && annotationForm.controls.labelFontSize.errors?.['max']) {
          <div class="error-message">
            <strong style="color: #ff8080;">Label Font Size must be at most 72.</strong>
          </div>
        }
    </div>

    <div class="control-row">
        <div class="control no-margin">
            <label for="notes">Notes:</label>
            <textarea
                class="form-control"
                id="notes"
                name="notes"
                formControlName="notes"
            ></textarea>
        </div>
    </div>

    <div class="control-row">
        <div class="control no-margin">
            <label for="isPrivate">Private (check this if you don't want to make this annotation available for other users):</label>
            <p-checkbox
                id="isPrivate"
                name="isPrivate"
                formControlName="isPrivate"
                [style]="{ width: '100%' }"
                binary="true"
            ></p-checkbox>
        </div>
    </div>

    <div class="control-row">
        <div class="control no-margin">
            <label for="visibleForUser">Visible For User (uncheck this if you wish to hide this annotation for yourself):</label>
            <p-checkbox
                id="visibleForUser"
                name="visibleForUser"
                formControlName="visibleForUser"
                [style]="{ width: '100%' }"
                binary="true"
            ></p-checkbox>
        </div>
    </div>

    @if (shouldShowBreakSeriesOption()) {
    <div class="control-row">
        <div class="control no-margin">
            <label for="shouldBreakSeries">Should Break Series (check this if this annotation should break the graph series line):</label>
            <p-checkbox
                id="shouldBreakSeries"
                name="shouldBreakSeries"
                formControlName="shouldBreakSeries"
                [style]="{ width: '100%' }"
                binary="true"
            ></p-checkbox>
        </div>
    </div>
    }

    <!-- Multi-Selects -->
    <div class="selections-group mt-3" formGroupName="selections">
        <label class="form-label" for="selections">Associations</label>

     <!-- Targets -->
        <div class="control-row">
            <div class="control no-margin">
                <label for="targets">Targets:</label>
                <p-multiSelect
                    id="targets"
                    name="targets"
                    formControlName="targetIDs"
                    [options]="selectableTargets"
                    optionLabel="label"
                    optionValue="value"
                    [showClear]="true"                
                    [style]="{ width: '100%' }"
                    [appendTo]="'body'"
                ></p-multiSelect>
            </div>
        </div>

        <!-- Behaviors -->
        <div class="control-row">
            <div class="control no-margin">
                <label for="behaviors">Behaviors:</label>
                <p-multiSelect
                    id="behaviors"
                    name="behaviors"
                    formControlName="behaviorIDs"
                    [options]="selectableBehaviors"
                    optionLabel="label"
                    optionValue="value"
                    [showClear]="true"
                    [style]="{ width: '100%' }"
                    [appendTo]="'body'"
                ></p-multiSelect>
            </div>
        </div> 

        <!-- Programs -->
        <div class="control-row">
            <div class="control no-margin">
                <label for="programs">Programs:</label>
                <p-multiSelect
                    id="programs"
                    name="programs"
                    formControlName="programIDs"
                    [options]="selectablePrograms"
                    optionLabel="label"
                    optionValue="value"
                    [showClear]="true"
                    [style]="{ width: '100%' }"
                    [appendTo]="'body'"
                ></p-multiSelect>
            </div>
        </div>

        <!-- Skill Areas -->
        <div class="control-row">
            <div class="control no-margin">
                <label for="skillAreas">Skill Areas:</label>
                <p-multiSelect
                    id="skillAreas"
                    name="skillAreas"
                    formControlName="skillAreaIDs"
                    [options]="selectableSkillAreas"
                    optionLabel="label"
                    optionValue="value"
                    [showClear]="true"
                    [style]="{ width: '100%' }"
                    [appendTo]="'body'"
                ></p-multiSelect>
            </div>
        </div>   

        @if (hasSelectionError) {
            <div class="error-message">
              <strong style="color: #ff8080;">Please select at least one item from any of the above options.</strong>
            </div>
            }  
    </div>
  
    <p class="actions" id="behaviorActions">
      <button type="button" (click)="onCancel()">Cancel</button>
      <button type="submit" id="saveBehaviorButton">{{ actionName }}</button>
    </p>
  </form>
  
